(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller(
			'manageSubscriptions',
			manageSubscriptions
		);

	manageSubscriptions.$inject = [];

	function manageSubscriptions() {
	}
})();
